import { useContext, useEffect } from "react";

import SimulationContext from "../contexts/Simulation";

const useIncrementSimulationStep = () => {
    const [simParams, setSimParams] = useContext(SimulationContext);

    useEffect(() => {
        if (process.env?.NODE_ENV === 'development')
            console.log(simParams);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [simParams.currentStep]);
    
    const incrementSimulationStep = (params) => {
        setSimParams({
            ...params,
            currentStep: simParams.currentStep + 1,
            completeSteps: Math.max(simParams.currentStep + 1, simParams.completeSteps)
        });
    }

    return { simParams, incrementSimulationStep };
};

export default useIncrementSimulationStep;
